import {Component, OnInit} from '@angular/core';
import { originalPrice } from '../../../config/price';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, RouterLink, FontAwesomeModule]
})
export class PricingComponent implements OnInit {
  public price = originalPrice;

  public constructor(private googleAnalyticsService: GoogleAnalyticsService) {
  }

  public ngOnInit(): void {
    this.googleAnalyticsService.sendEvent('pricing_view');
  }
}
